const isDev = process.env.NODE_ENV !== 'production';
const noop = () => {};

export const logger = {
  error: isDev ? (...args) => console.error(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  info: isDev ? (...args) => console.info(...args) : noop,
};
